<script lang="ts" setup>
  import type { TopicLocale } from '@/types'
  import TopicsConfig from '@/config/deck/topics.json'
  import { computed, toRefs } from 'vue'

  const model = defineModel({ required: true, type: String })

  const props = defineProps<{
    langSelected: TopicLocale
  }>()

  const { langSelected } = toRefs(props)

  const topicsList = computed(() => TopicsConfig[langSelected.value])

  function getTopicsIcon(topicId: string | undefined) {
    if (!topicId || !topicsList.value) return 'game-icons--newspaper'
    return (
      topicsList.value?.find(topic => topic.value == topicId)?.icon ||
      'game-icons--newspaper'
    )
  }
</script>

<template>
  <div class="relative grow">
    <select
      v-model="model"
      name="topic"
      class="select select-lg border-0 pl-10 font-semibold focus:outline-0"
      aria-label="Topic selection"
    >
      <option
        v-for="{ label, value } in topicsList"
        :key="value"
        :value="value"
      >
        {{ label }}
      </option>
    </select>
    <div class="absolute top-1/2 left-4 transform-[translateY(-50%)]">
      <span :class="`icon-[${getTopicsIcon(model)}]`"></span>
    </div>
  </div>
</template>
